export const mergePlanAndFactDatasets = (planDataset: any[], factDataset: any[]) => {
  return planDataset.map((planData, index) => ({
    ...planData,
    fact: factDataset[index][0]?.fact || 0,
  }))
}
